<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import useExternalUrlCallbacks from '@/composables/useExternalUrlCallbacks'

import UiButton from '@/components/ui/UiButton.vue'

const { t } = useI18n()
const { reloadPage } = useExternalUrlCallbacks()
</script>

<template>
  <div class="flex flex-col items-center justify-center mb-4 sm:mb-8 max-w-2xl">
    <h1 class="text-2xl font-bold mb-2 text-center">
      {{ t('error_screen.title') }}
    </h1>
    <p class="text-sm text-center">
      {{ t('error_screen.description') }}
    </p>
  </div>
  <div class="flex gap-4 justify-center">
    <UiButton @click="reloadPage()">{{
      t('error_screen.cta_reload')
    }}</UiButton>
  </div>
</template>
